import React, {FC, RefObject} from 'react';
import styled from 'styled-components';

import {DropdownItemIcon} from '../../../../../../../src/components/common/dropdowns/dropdownItemIcon';
import {Handler} from '../../../../../../shared/helpers/src/react/reactHelpers';
import {Dropdown} from '../../../../../../shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../../../shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../../shared/ui/src/components/dropdowns/dropdownItemContent';
import {InteractiveList} from '../../../../../../shared/ui/src/components/interactiveList/interactiveList';

/*
 * Props.
 */

interface ContactsManagerSearchDropdownProps {
  query: string;
  anchor: RefObject<HTMLDivElement>;
  onQuerySelect: Handler;
}

/*
 * Style.
 */

const StyledSearchList = styled(InteractiveList)`
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
  padding: 8px 0;
`;

/*
 * Component.
 */

export const ContactsManagerSearchDropdown: FC<ContactsManagerSearchDropdownProps> = (props) => {
  const {anchor, query, onQuerySelect} = props;
  if (!query) {
    return null;
  }
  return (
    <Dropdown anchor={anchor} isExclusive={false} width={anchor.current?.clientWidth}>
      <StyledSearchList shouldSelectWithTab shouldSelectFirst>
        <DropdownItem onSelect={onQuerySelect}>
          <DropdownItemIcon label={null} iconName="searchSmall" iconSize={16} />
          <DropdownItemContent>{query}</DropdownItemContent>
        </DropdownItem>
      </StyledSearchList>
    </Dropdown>
  );
};
